/**
 * The menu keys that have a screen behind them today.
 *
 * This is the single fact both the menu and the router need, and it lives here — in a module with
 * no React in it — so `menu.ts` can stay a plain manifest and the registry can be typed against it.
 *
 * Declaring it once is the point. The alternative, a `pending: true` flag hand-maintained in
 * `menu.ts`, drifts the moment a screen ships and someone forgets to delete the flag: the item
 * stays dimmed and unreachable even though the page exists. Here, adding a key is a compile error
 * until `pages` in `registry.tsx` has an entry for it, and the menu re-derives itself.
 */
export const builtPageKeys = [
  'today',
  'branch',
  'user',
  'role',
  'fy',
  'numbering',
  'company',
  'settings',
  'categories',
  'items',
  'attributes',
  'units',
  'receipts',
  'availability',
  'showroom',
  'calendar',
  'customers',
  'vendors',
  'employees',
  'parties',
  'returns',
  'deposits',
  'approvals',
  'disputes',
  'cleaning',
  'alterations',
  'ratecards',
  'bookings',
  'invoices',
  'purchases',
  'bills',
  'vendorpayments',
  'outstanding',
  'cash',
  'expenses',
  'pos',
  'reports',
] as const;

export type BuiltPageKey = (typeof builtPageKeys)[number];

const built: ReadonlySet<string> = new Set(builtPageKeys);

export function isBuilt(key: string): key is BuiltPageKey {
  return built.has(key);
}
